// global Raven
import React, { PureComponent } from 'react';

import { HotmartRum } from '@hot-observability-js/react';
import PropTypes from 'prop-types';

import './ErrorBoundary.scss';

export default class ErrorBoundary extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    fallback: PropTypes.node,
    t: PropTypes.func
  };

  state = {
    hasError: null,
    error: null
  };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    HotmartRum.captureException(error);
  }

  clear = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    const { fallback, children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      if (typeof fallback === 'function') {
        return fallback({ clear: this.clear });
      }

      if (typeof fallback !== 'undefined') {
        return fallback;
      }

      return (
        <div className="error__boundary">
          <h2>{'Oh-no! Something went wrong'}</h2>
          <p>{'Please reload page or contact support'}</p>
        </div>
      );
    }

    return children;
  }
}
